



































import { Component, Prop, Vue } from 'vue-property-decorator';
import QuestionContainer from '@/components/questions/QuestionContainer.vue';
import {
  CollectionItem,
  CollectionItemType,
} from '@/resource/collection-item/collection-item.model';
import PaperItemWrapper from './PaperItemWrapper.vue';

@Component({
  components: { QuestionContainer, PaperItemWrapper },
})
export default class PaperItem extends Vue {
  @Prop({ default: null })
  paperItem: CollectionItem;

  @Prop({ required: true })
  index: number;

  @Prop({ default: false })
  hasSubjectiveItems: boolean;

  @Prop({ default: 1 })
  subjectiveTitleIndex: number;

  @Prop({ default: false })
  showRearrange: boolean;

  @Prop({ default: 0 })
  totalPaperItems: number;

  get numberOrder() {
    return this.isObjective ? this.index : this.index - 1;
  }

  get isObjective() {
    return this.paperItem.questionObjective ? true : false;
  }

  get isTitle() {
    return this.paperItem.collectionItemType === CollectionItemType.Title;
  }

  get question() {
    return (
      this.paperItem.questionObjective || this.paperItem.questionSubjective
    );
  }

  get languages() {
    return this.paperItem.languages;
  }

  get isHideSubjectiveTitle() {
    return !this.hasSubjectiveItems && this.isTitle && this.index !== 0;
  }

  get isHideObjectiveTitle() {
    return this.isTitle && this.index === 0 && this.subjectiveTitleIndex === 1;
  }

  created() {
    if (this.isTitle && this.index !== 0) {
      this.$emit('updateSubjectiveTitleIndex', this.index);
    }
  }
}
